import { render, staticRenderFns } from "./UploadNewProductionFw.vue?vue&type=template&id=5d84ddbf&"
import script from "./UploadNewProductionFw.vue?vue&type=script&lang=js&"
export * from "./UploadNewProductionFw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports